import React from 'react';
import { Link } from 'react-router-dom';

const Gallery = () => {
  return (
    <section className="py-12 md:py-24 bg-white dark:bg-slate-900 overflow-hidden" id="gallery">
      <div className="container mx-auto px-6 md:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">
            Transformations
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white mb-6">
            Real Results, Real Smiles
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8 rounded-full"></div>
          <p className="text-lg text-slate-600 dark:text-slate-400 font-light leading-relaxed">
            Witness the life-changing transformations of our happy patients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto mb-16">
          {/* Before Image */}
          <div className="relative group overflow-hidden rounded-2xl shadow-soft hover:shadow-glow transition-all duration-500">
            <img
              alt="Dental patient smiling before treatment in Kottawa"
              className="w-full h-80 object-cover grayscale group-hover:grayscale-0 transition duration-700 transform group-hover:scale-105"
              src="/images/gallery-smile-2.png"
            />
            <div className="absolute top-4 left-4 bg-slate-800/80 backdrop-blur text-white px-4 py-1.5 rounded-lg text-xs font-bold shadow-md tracking-wider">
              HAPPY PATIENT
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900/90 to-transparent p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              <p className="text-white font-medium">Confident & Radiant</p>
            </div>
          </div>

          {/* After Image */}
          <div className="relative group overflow-hidden rounded-2xl shadow-soft hover:shadow-glow transition-all duration-500">
            <img
              alt="Dental patient after teeth whitening and veneers in Kottawa"
              className="w-full h-80 object-cover transform group-hover:scale-105 transition duration-700"
              src="/images/gallery-smile-1.png"
            />
            <div className="absolute top-4 left-4 bg-primary text-white px-4 py-1.5 rounded-lg text-xs font-bold shadow-md tracking-wider">
              AFTER
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary/90 to-transparent p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              <p className="text-white font-medium">Restored Healthy Smile</p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link
            className="inline-flex items-center gap-2 border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-3 rounded-full font-bold transition-all duration-300 group"
            to="/gallery-page"
          >
            View More Success Stories
            <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
